export const findEnvAttr = (attr: string): any => {
	return process.env[attr]; // eslint-disable-line no-undef
};
